<template>
  <div class="declaracao-cadastro">
    <Dialog
      :visible.sync="showCadastro"
      :modal="true"
      :closable="false"
    >
    <h1 class="titulo-header">
      Nova Declaração
      <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text" @click="showCadastro = false"/>
    </h1>
      <div id="topo" class="scrolable-dialog">
        <error-list :erros="erros" v-if="erros" />
        <div class="row">
          <div class="col-md-6 mb-2">
            <label for="descServico">Layout:</label>
            <span class="p-fluid">
              <a href="https://s3.amazonaws.com/el.com.br/nfse/layout_dap_nfse.pdf" style="padding-left: 2px;" target="_blank">Clique aqui e faça o download do Layout</a>
            </span>
          </div>
        </div> 
        <div class="row">
          <div class="col-md-2 mb-2">
            <label for="descServico">Ano:</label>
            <span class="p-fluid">
              <InputText v-model="declaracao.ano" disabled />
            </span>
          </div>
          <div class="col-md-2 mb-2">
            <label for="descServico">Mês:</label>
            <span class="p-fluid">
              <InputText v-model="declaracao.mes" disabled />
            </span>
          </div>
          <div class="col-md-2 mb-2">
            <label>Importação XML:</label>
            <span class="p-fluid">
              <input type="file" @change="onFileChanged" accept=".xml" />
            </span>
          </div>
          <div class="col-md-2 mb-2">
            <label> </label>
            <span class="p-fluid">
              <Button
                v-if="selectedFile"
                @click="onUpload()"
                label="Upload"
                type="button"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
              />
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mb-2">
            <label for="emolumento">Emolumento: *</label>
            <span class="p-fluid">
              <AutoComplete
                id="emolumento"
                v-model="selectedEmolumento"
                :dropdown="true"
                :suggestions="filteredEmolumentos"
                field="detail"
                placeholder="Pesquisar"
                @complete="searchEmolumento($event)"
                @item-select="atualizarDadosTela()"
              >
                <template #item="slotProps">
                  <div class="p-fluid" style="max-width: 50vw">
                    {{ slotProps.item.detail }}
                  </div>
                </template>
              </AutoComplete>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 mb-2">
            <label for="quantidade">Quantidade: *</label>
            <span class="p-fluid">
              <money
                id="quantidade"
                name="quantidade"
                v-model="quantidade"
                class="p-inputtext input-right"
              ></money>
            </span>
          </div>
          <div class="col-md-2 mb-2">
            <label for="valor">Valor:</label>
            <span class="p-fluid">
              <money
                id="valor"
                name="valor"
                v-model="valorEmolumento"
                v-bind="money"
                disabled="true"
                class="p-inputtext input-right"
              ></money>
            </span>
          </div>
          <div class="col-md-2 mb-2">
            <label for="aliquota">Alíquota: *</label>
            <span class="p-fluid">
              <money
                id="aliquota"
                name="aliquota"
                v-model="aliquota"
                v-bind="percent"
                class="p-inputtext input-right"
              ></money>
            </span>
          </div>
        </div>

        <div class="botoes-avancar-voltar" style="margin-top: 10px">
              <Button
                @click="adicionarListagem()"
                href="#topo"
                type="button"
                label="Adicionar"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="loading"
              />
              <Button
                @click="showCadastro = false"
                type="button"
                label="Fechar"
                class="p-button-primary mr-2 p-button-danger"
                icon="pi pi-times"
                v-if="listEmolumentos.length === 0"
              />
        </div>

        <div v-if="listEmolumentos.length > 0">
          <hr />
        </div>

        <div class="row pr-3 pl-3" v-if="listEmolumentos.length > 0">
          <h4 class="panel-title">
            <span class="title">Emolumentos da Declaração.</span>
          </h4>
          <DataTable
            :value="listEmolumentos"
            :paginator="true"
            :rows="10"
            class="p-datatable-responsive"
            :key="0"
            :autoLayout="true"
            style="min-width: 100%"
            :rowClass="rowClass"
          >
            <Column headerStyle="width: 1%">
              <template #body="slotProps">
                <div :class="lineClass(slotProps.data)">
                  <Button
                    @click="removerItem(slotProps.data)"
                    type="button"
                    label=""
                    class="p-button-primary mr-2 p-button-danger"
                    icon="pi pi-times"
                  />
                </div>
              </template>
            </Column>
            <Column headerStyle="width: 40%" field="id" header="Emolumento">
              <template #body="slotProps">
                <div :class="lineClass(slotProps.data)">
                  {{ slotProps.data.detail }}
                </div>
              </template>
            </Column>
            <Column
              headerStyle="width: 10%"
              field="quantidade"
              header="Quantidade"
              bodyStyle="text-align:right"
            >
              <template #body="slotProps">
                <div :class="lineClass(slotProps.data)">
                  {{ slotProps.data.quantidade }}
                </div>
              </template>
            </Column>
            <Column
              headerStyle="width: 10%"
              field="valor"
              header="Valor"
              bodyStyle="text-align:right"
            >
              <template #body="slotProps">
                <div :class="lineClass(slotProps.data)">
                  {{ slotProps.data.valorFormatado }}
                </div>
              </template>
            </Column>
            <Column
              headerStyle="width: 10%"
              field="aliquota"
              header="Alíquota"
              bodyStyle="text-align:right"
            >
              <template #body="slotProps">
                <div :class="lineClass(slotProps.data)">
                  {{ slotProps.data.aliquotaFormatado }}
                </div>
              </template>
            </Column>
            <Column
              headerStyle="width: 10%"
              field="valorIssFormatado"
              header="Valor Total"
              bodyStyle="text-align:right"
            >
              <template #body="slotProps">
                <div :class="lineClass(slotProps.data)">
                  {{ slotProps.data.valorIssFormatado }}
                </div>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <div class="container" v-if="listEmolumentos.length > 0">
        <div class="row">
          <div>
            <Button
              @click="gravar()"
              href="#topo"
              type="button"
              label="Gravar"
              class="p-button-primary mr-2 p-button-success"
              icon="pi pi-check"
              :disabled="loading"
            />
          </div>

          <div>
            <Button
              @click="showCadastro = false"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import money from "../conf/config.money";
import percent from "../conf/config.percent";
import LoginService from "../services/acesso/login.service";
import Declaracao from "../models/tributario/Declaracao";
import DeclaracaoEmolumento from "../services/tributario/declaracao.emolumento.service";
import CartorioService from "../services/nfse/cartorio.service";

export default {
  name: "DeclaracaoCartorioCadastro",

  data() {
    return {
      money: money,
      percent: percent,
      loading: false,
      erros: [],
      idCliente: null,
      showCadastro: false,
      currentUser: null,
      declaracao: new Declaracao(),
      selectedEmolumento: null,
      filteredEmolumentos: [],
      showOrientacoes: false,
      quantidade: 1,
      aliquota: 5,
      valorEmolumento: 0,
      listEmolumentos: [],
      selectedFile: null,
      objectFile: null,
    };
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.idCliente = this.currentUser.usuario.idCliente;
    this.$root.$on("declaracaoSimplificada:novo", () => {
      this.novo();
    });
  },

  methods: {
    rowClass() {
      return null;
    },
    lineClass() {
      return null;
    },
    novo() {
      this.showCadastro = true;
      this.erros = [];
      this.declaracao.ano = this.$parent.filtroAno.key;
      this.declaracao.mes = this.$parent.filtroMes.key;
      this.declaracao.idContribuinte = this.currentUser.contribuinte.idContribuinte;
      this.declaracao.idUsuario = this.currentUser.usuario.idUsuario;
      this.declaracao.idCliente = this.currentUser.usuario.idCliente;
      this.declaracao.valorServico = 0;
      this.declaracao.valorDesconto = 0;
      this.declaracao.aliquota = 0;
      this.declaracao.observacao = "";
      this.selectedServico = null;
      this.listEmolumentos = [];
      this.selectedFile = null;
      this.objectFile = null;
    },
    searchEmolumento(event) {
      setTimeout(async () => {
        this.filteredEmolumentos = await CartorioService.findAllEmolumentosByFiltro(
          this.idCliente,
          event.query
        );
        console.log(this.selectedEmolumento);
      }, 250);
    },
    atualizarDadosTela() {
      this.processando(true);
      if (this.selectedEmolumento && this.selectedEmolumento.id) {
        this.valorEmolumento = this.selectedEmolumento.valor;
      }
      this.processando(false);
    },
    gravar() {
      this.processando(true);

      if (!this.listEmolumentos || this.listEmolumentos.length === 0) {
        this.$root.$emit(
          "alert:warn",
          "Selecione ao menos um emolumento para realizar a Declaração!"
        );
        this.processando(false);
      } else {
        this.declarar().then(() => {
          this.processando(false);
        });
      }
    },
    declarar() {
      this.processando(true);

      console.log(this.listEmolumentos);
      DeclaracaoEmolumento.declarar(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.declaracao.ano,
        this.declaracao.mes,
        "N",
        this.listEmolumentos
      ).then(
        (response) => {
          console.log(response);
          this.$root.$emit("alert:success", "Declaração gerada com sucesso!");
          this.processando(false);
          this.$parent.pesquisar();
          this.showCadastro = false;
        },
        (error) => {
          console.log(error);
          let errorMessage = "Erro ao gerar Declaração!";
          this.$root.$emit("alert:warn", "");
          if (error.response) {
            const errors = Array.isArray(error.response.data)
              ? error.response.data
              : [error.response.data];

            errors.forEach(err => {
              this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: err,
                life: 5000
              });
              });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: errorMessage,
              life: 5000
            });
          }
          this.processando(false);
        }
      );
    },
    adicionarListagem() {
      this.processando(true);
      this.erros.splice(0, this.erros.length);
      if (!this.selectedEmolumento) {
        this.erros.push("Informe um Emolumento!");
      } else {
        if (
          !this.selectedEmolumento.valor ||
          this.selectedEmolumento.valor <= 0
        ) {
          this.erros.push("Informe um valor válido!");
        }
        if (!this.aliquota || this.aliquota < 2 || this.aliquota > 5) {
          this.erros.push("Informe uma alíquota válida, entre 2 e 5%!");
        }
      }
      if (!this.quantidade || this.quantidade <= 0) {
        this.erros.push("Informe uma quantidade válida!");
      }
      if (this.erros.length === 0) {
        let item = this.listEmolumentos.find(
          (item) => item.emolumento.id === this.selectedEmolumento.id
        );
        console.log(this.selectedEmolumento);

        if (!item) {
          this.carregarDados(
            this.selectedEmolumento,
            this.aliquota,
            this.quantidade
          );
          this.selectedEmolumento = null;
          this.valorEmolumento = 0;
          this.quantidade = 1;
        } else {
          this.$root.$emit(
            "alert:warn",
            "Emolumento já adicionado nesta declaração!"
          );
        }
      }
      this.processando(false);
    },
    removerItem(data) {
      this.processando(true);
      this.listEmolumentos.splice(this.listEmolumentos.indexOf(data), 1);
      this.processando(false);
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      this.selectedFile = file;
    },
    onUpload() {
      this.processando(true);
      DeclaracaoEmolumento.upload(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.selectedFile
      ).then(
        (response) => {
          this.carregarDadosImportados(response.data);
          this.$root.$emit(
            "alert:success",
            "Emolumentos importados com sucesso!"
          );
        },
        (error) => {
          let errorMessage = "Houve um problema ao realizar o Upload!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$root.$emit("alert:error", errorMessage);
        }
      );
      this.processando(false);
    },
    carregarDadosImportados(emolumentos) {
      this.listEmolumentos = [];
      this.declaracao.ano = emolumentos[0].ano;
      this.declaracao.mes = emolumentos[0].mes;
      emolumentos.map((emolumento) => {
        this.carregarDados(emolumento, 5, emolumento.quantidade);
      });
    },
    carregarDados(emolumento, aliquota, quantidade) {
      const totalIss = (
        (quantidade * emolumento.valor * aliquota) /
        100
      ).toFixed(2);
      const novoItem = {
        emolumento: emolumento,
        detail: emolumento.detail,
        quantidade: quantidade,
        valor: emolumento.valor.toFixed(2),
        aliquota: aliquota.toFixed(2),
        valorIss: totalIss,
        valorIssFormatado: totalIss.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
        valorFormatado: emolumento.valor.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
        aliquotaFormatado: `% ${aliquota.toLocaleString("pt-BR")}`,
      };
      this.listEmolumentos.push(novoItem);
    },
  },
  computed: {
    isBloqueado() {
      return this.currentUser && this.currentUser.idBolBloquearSistema && this.currentUser.idBolBloquearSistema === 'S';
    },
  },
};
</script>

<style scoped>
.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.p-inputtext:disabled {
  color: #a6a6a6;
  border-color: #a6a6a6;
}

textarea {
  width: 100%;
  border-radius: 12px;
}
</style>
